var SENTRY_RELEASE;SENTRY_RELEASE={name: "NEXT", version: "3.28.6"};